module.exports = __webpack_public_path__ + "static/media/hero.d43caaa1.png";